// import { LEAD_TYPES, STATUS_TYPES } from "../../constants/leads";
import { Chip, MenuItem, TextField, Tooltip } from "@mui/material";
import { AGENT_IMAGES_URL, PROPERTY_IMAGES_URL } from "../../constants/url";
import React, { useEffect, useState } from "react";
import {
  LEAD_DEAL_DONE_ID,
  LEAD_VIEWING_ARRANGE_ID,
  LEAD_VIEWING_DONE_ID,
  STATUS_TYPES,
} from "../../constants/leads";
// import { Chip, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
// import { PROPERTY_IMAGES_URL } from "../../constants/url";
// import React, { useState } from "react";
import { correctDate } from "../../constants/customFunction";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EDIT_LEAD_ROUTE } from "../../constants/routes";
import StatusDescription from "./lead/status/StatusDescription";
import { useLeadStatusQuery } from "../../redux/api/leadsApi";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { selectCurrentagency } from "../../redux/features/authSlice";

export const PROPERTY_LEADS_COLUMNS = (refetch) => [
  {
    accessorKey: "agentname",
    header: "Staff Name",
    size: 20,
  },

  {
     accessorKey: "leadTag",
     header: "Lead Ref No",
     size: 20,
     Cell: ({ row }) => {
       const currentAgency = useSelector(selectCurrentagency);
       const leadId = row.original?.leadid;
 
       // If no leadId, show nothing (keeps row height consistent)
       if (!leadId) return <div style={{ minHeight: 24 }} />;
 
       const getLeadIdBackgroundColor = (leadTime) => {
         const now = dayjs();
         const leadDate = dayjs(leadTime);
         const diffInHours = now.diff(leadDate, "hour");
 
         if (diffInHours < 24) return "";
         else if (diffInHours >= 24 && diffInHours < 48) return "orange";
         else return "red";
       };
 
       const backgroundColor = getLeadIdBackgroundColor(
         row.original?.followupdate
       );
 
       // Build safe label (avoid showing undefined)
       const tagPrefix = currentAgency?.agcRefTag
         ? `${currentAgency.agcRefTag}-`
         : "";
       const label = `${tagPrefix}L-${leadId}`;
 
       return (
         <Chip
           label={label}
           size="small"
           sx={{
             cursor: "pointer",
             fontSize: 12,
             backgroundColor: backgroundColor || "#56C662",
             color: "white",
           }}
         />
       );
     },
   },
  {
    accessorKey: "leadUpdatedDate",
    header: "Updated Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.leadUpdatedDate;
      if (!value) return null;

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },

  {
    accessorKey: "followupdate",
    header: "Follow up Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.followupdate;
      if (!value) return "Not Scheduled";

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },

  {
    accessorKey: "firstname", // keep this for filtering
    header: "Full Name",
    size: 30,
    Cell: ({ row }) => {
      const first = row.original.firstname || "";
      const last = row.original.lastname || "";
      const fullName = `${first} ${last}`.trim();

      return (
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // ✅ limit to 2 lines max
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          {fullName || "—"}
        </div>
      );
    },
    filterFn: "includesString", // ensures filtering still uses firstname
  },
  {
    accessorKey: "userphone",
    header: "Lead Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },

  {
    accessorKey: "leadHistory",
    header: "History",
    size: 20,
    Cell: ({ row }) => {
      return (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`/agent/leads/${row.original.agentid}/view/${row.original.userid}/history/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>

          <span className="text-sm font-medium transition-all group-hover:ms-4">
            {" "}
            History{" "}
          </span>
        </Link>
      );
    },
  },

  {
    accessorKey: "status",
    header: "Status",
    size: 25,
    Cell: ({ row }) => {
      const [status, setStatus] = useState(
        row.original.leadStatus?.toString() || ""
      );
      const [updatedStatus, setUpdatedStatus] = useState(status);
      const [updatedStatusName, setUpdatedStatusName] = useState("");

      const [showComponent, setShowComponent] = useState(false);
      const navigate = useNavigate();
      const { data: STATUS = [] } = useLeadStatusQuery();
      const handleChange = (event) => {
        const newStatus = event.target.value;
        setUpdatedStatus(newStatus);
        setUpdatedStatusName(
          STATUS.find((item) => item.statusId === newStatus)?.statusName || ""
        );

        const currentPath = window.location.pathname;
        let newPath;

        if (newStatus === LEAD_VIEWING_ARRANGE_ID) {
          newPath = `/agent/leads/${row.original.agentid}/view/${row.original.userid}/viewingarranged/${row.original.leadid}`;
        } else if (newStatus === LEAD_VIEWING_DONE_ID) {
          newPath = `/agent/leads/${row.original.agentid}/view/${row.original.userid}/viewdone/${row.original.leadid}`;
        } else if (newStatus === LEAD_DEAL_DONE_ID) {
          newPath = `/agent/leads/${row.original.agentid}/view/${row.original.userid}/deal/${row.original.leadid}`;
        }

        if (
          newStatus === LEAD_VIEWING_ARRANGE_ID ||
          newStatus === LEAD_VIEWING_DONE_ID ||
          newStatus === LEAD_DEAL_DONE_ID
        ) {
          setShowComponent(false);
          navigate(newPath);
        } else {
          setShowComponent(true);
        }
      };

      useEffect(() => {
        const newStatus = row.original.leadStatus;
        setStatus(newStatus);
      }, [row.original.leadStatus]);

      return (
        <>
         <TextField
            variant="outlined"
            size="small"
            select
            value={status}
            onChange={handleChange}
            SelectProps={{
              displayEmpty: true,
              MenuProps: {
                sx: { maxHeight: "380px" },
                PaperProps: {
                  sx: {
                    maxWidth: 180, // limit dropdown width
                    "& .MuiMenuItem-root": {
                      whiteSpace: "normal", // ✅ allow wrapping
                      wordBreak: "break-word", // ✅ break long words
                      lineHeight: 1.3,
                      py: 0.8,
                    },
                  },
                },
              },
              renderValue: () => {
                const selectedStatus = STATUS.find(
                  (option) => option.statusId.toString() === status?.toString()
                );
                return selectedStatus ? (
                  <span
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      lineHeight: 1.2,
                      display: "inline-block",
                    }}
                  >
                    {selectedStatus.statusName}
                  </span>
                ) : (
                  <span>Status</span>
                );
              },
            }}
            sx={{ width: "180px" }} // ✅ smaller width now works well
          >
            {STATUS?.map((option) => (
              <MenuItem
                key={option.statusId}
                value={option.statusId}
                sx={{
                  whiteSpace: "normal", // ✅ wrap text into 2–3 lines
                  wordBreak: "break-word",
                  lineHeight: 1.3,
                }}
              >
                {option.statusName}
              </MenuItem>
            ))}
          </TextField>

          {showComponent && (
            <div className="fixed top-0 left-0 xl:top-5 xl:left-20 flex items-center justify-center w-full h-[100vh] z-10 bg-customGray">
              <div className="w-auto sm:w-[600px] h-[350px] bg-white rounded-xl flex flex-col justify-center items-center">
                <StatusDescription
                  setStatus={setStatus}
                  setShowVerify={setShowComponent}
                  selectedLeadStatus={updatedStatus}
                  selectedLeadStatusName={updatedStatusName}
                  leadData={row.original}
                  refetch={refetch}
                />
              </div>
            </div>
          )}
        </>
      );
    },
  },
  {
    header: "Note",
    accessorKey: "note",
    Cell: ({ row }) => {
      const note = row.original.note || "—";

      return (
        <Tooltip title={note} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {note}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },
 {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },
 
  {
    accessorKey: "PriorityName",
    header: "Priority Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },
  
  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },

  {
    accessorKey: "LeadTypeName",
    header: "Lead Type",
    size: 20,
  },

  {
    accessorKey: "MediumName",
    header: "Medium Name",
    size: 20,
  },
  {
    accessorKey: "SourceName",
    header: "Source Type",
    size: 20,
  },

{
    header: "Description",
    accessorKey: "description",
    Cell: ({ row }) => {
      const description = row.original.description || "—";

      return (
        <Tooltip title={description} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {description}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },
  {
    accessorKey: "leadTime",
    header: "Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadTime).toLocaleDateString()}</div>
    ),
  },

  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },

  {
    accessorKey: "propertydata",
    header: "Property",
    size: 15,
    Cell: ({ row }) => {
      const { id } = useParams();
      return row.original.propertyid === null ? (
        <span>Disable</span>
      ) : (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`/agent/leads/${row.original.agentid}/view/${row.original?.userid}/details/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Details
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "edit",
    header: "Edit",
    size: 15,
    Cell: ({ row }) => {
      const currentAgent = useSelector(selectCurrentagency);
      const agentRights = currentAgent.agentrights || {};

      return (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={EDIT_LEAD_ROUTE + row.original.leadid}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Edit
          </span>
        </Link>
      ) 
    },
  },
];

export const LEADS_POOL_COLUMNS = [
  {
    accessorKey: "leadSerialNo",
    header: "S.No",
    size: 30,
  },
  {
    accessorKey: "firstname",
    header: "First Name",
    size: 20,
  },
  {
    accessorKey: "lastname",
    header: "Last Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "userphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },
  {
    accessorKey: "userid",
    header: "User Id",
    size: 20,
  },
  {
    accessorKey: "leadid",
    header: "Lead Id",
    size: 20,
    // Cell: ({ row }) => <span>{row.original?.Properties[0]?.leadid}</span>,
  },

  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
];

export const VIEW_COLUMNS = (refetch) => [
 {
     accessorKey: "leadTag",
     header: "Lead Ref No",
     size: 20,
     Cell: ({ row }) => {
       const currentAgency = useSelector(selectCurrentagency);
       const leadId = row.original?.leadid;
 
       // If no leadId, show nothing (keeps row height consistent)
       if (!leadId) return <div style={{ minHeight: 24 }} />;
 
       const getLeadIdBackgroundColor = (leadTime) => {
         const now = dayjs();
         const leadDate = dayjs(leadTime);
         const diffInHours = now.diff(leadDate, "hour");
 
         if (diffInHours < 24) return "";
         else if (diffInHours >= 24 && diffInHours < 48) return "orange";
         else return "red";
       };
 
       const backgroundColor = getLeadIdBackgroundColor(
         row.original?.followupdate
       );
 
       // Build safe label (avoid showing undefined)
       const tagPrefix = currentAgency?.agcRefTag
         ? `${currentAgency.agcRefTag}-`
         : "";
       const label = `${tagPrefix}L-${leadId}`;
 
       return (
         <Chip
           label={label}
           size="small"
           sx={{
             cursor: "pointer",
             fontSize: 12,
             backgroundColor: backgroundColor || "#56C662",
             color: "white",
           }}
         />
       );
     },
   },

  {
  accessorKey: "leadUpdatedDate",
  header: "Updated Date",
  size: 10,
  Cell: ({ row }) => {
    const value = row.original.leadUpdatedDate;
    if (!value) return null;

    const date = new Date(value);
    const dateStr = date.toLocaleDateString();
    const timeStr = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return (
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
        <span>{dateStr}</span>
        <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
      </div>
    );
  },
},

{
  accessorKey: "followupdate",
  header: "Follow up Date",
  size: 10,
  Cell: ({ row }) => {
    const value = row.original.followupdate;
    if (!value) return "Not Scheduled";

    const date = new Date(value);
    const dateStr = date.toLocaleDateString();
    const timeStr = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return (
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
        <span>{dateStr}</span>
        <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
      </div>
    );
  },
},

  
 {
    accessorKey: "firstname", // keep this for filtering
    header: "Full Name",
    size: 30,
    Cell: ({ row }) => {
      const first = row.original.firstname || "";
      const last = row.original.lastname || "";
      const fullName = `${first} ${last}`.trim();

      return (
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // ✅ limit to 2 lines max
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          {fullName || "—"}
        </div>
      );
    },
    filterFn: "includesString", // ensures filtering still uses firstname
  },
 {
    accessorKey: "userphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  
  {
    accessorKey: "leadHistory",
    header: "History",
    size: 20,
    Cell: ({ row }) => {
      return (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`view/${row.original.userid}/history/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>

          <span className="text-sm font-medium transition-all group-hover:ms-4">
            {" "}
            History{" "}
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    size: 25,
    Cell: ({ row }) => {
      const [status, setStatus] = useState(
        row.original.leadStatus?.toString() || ""
      );
      const [updatedStatus, setUpdatedStatus] = useState(status);
      const [updatedStatusName, setUpdatedStatusName] = useState("");

      const [showComponent, setShowComponent] = useState(false);
      const navigate = useNavigate();
      const { data: STATUS = [] } = useLeadStatusQuery();

      const handleChange = (event) => {
        const newStatus = event.target.value;
        setUpdatedStatus(newStatus);
        setUpdatedStatusName(
          STATUS.find((item) => item.statusId === newStatus)?.statusName || ""
        );

        const currentPath = window.location.pathname;
        let newPath;

        if (newStatus === LEAD_VIEWING_ARRANGE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/viewingarranged/${row.original.leadid}`;
        } else if (newStatus === LEAD_VIEWING_DONE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/viewdone/${row.original.leadid}`;
        } else if (newStatus === LEAD_DEAL_DONE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/deal/${row.original.leadid}`;
        }

        if (
          newStatus === LEAD_VIEWING_ARRANGE_ID ||
          newStatus === LEAD_VIEWING_DONE_ID ||
          newStatus === LEAD_DEAL_DONE_ID
        ) {
          setShowComponent(false);
          navigate(newPath);
        } else {
          setShowComponent(true);
        }
      };

      useEffect(() => {
        const newStatus = row.original.leadStatus;
        setStatus(newStatus);
      }, [row.original.leadStatus]);

      return (
        <>
           <TextField
            variant="outlined"
            size="small"
            select
            value={status}
            onChange={handleChange}
            SelectProps={{
              displayEmpty: true,
              MenuProps: {
                sx: { maxHeight: "380px" },
                PaperProps: {
                  sx: {
                    maxWidth: 180, // limit dropdown width
                    "& .MuiMenuItem-root": {
                      whiteSpace: "normal", // ✅ allow wrapping
                      wordBreak: "break-word", // ✅ break long words
                      lineHeight: 1.3,
                      py: 0.8,
                    },
                  },
                },
              },
              renderValue: () => {
                const selectedStatus = STATUS.find(
                  (option) => option.statusId.toString() === status?.toString()
                );
                return selectedStatus ? (
                  <span
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      lineHeight: 1.2,
                      display: "inline-block",
                    }}
                  >
                    {selectedStatus.statusName}
                  </span>
                ) : (
                  <span>Status</span>
                );
              },
            }}
            sx={{ width: "180px" }} // ✅ smaller width now works well
          >
            {STATUS?.map((option) => (
              <MenuItem
                key={option.statusId}
                value={option.statusId}
                sx={{
                  whiteSpace: "normal", // ✅ wrap text into 2–3 lines
                  wordBreak: "break-word",
                  lineHeight: 1.3,
                }}
              >
                {option.statusName}
              </MenuItem>
            ))}
          </TextField>
          {showComponent && (
            <div className="fixed top-0 left-0 xl:top-5 xl:left-20 flex items-center justify-center w-full h-[100vh] z-10 bg-customGray">
              <div className="w-auto sm:w-[600px] h-[350px] bg-white rounded-xl flex flex-col justify-center items-center">
                <StatusDescription
                  setStatus={setStatus}
                  setShowVerify={setShowComponent}
                  selectedLeadStatus={updatedStatus}
                  selectedLeadStatusName={updatedStatusName}
                  leadData={row.original}
                  refetch={refetch}
                />
              </div>
            </div>
          )}
        </>
      );
    },
  },
  {
    header: "Note",
    accessorKey: "note",
    Cell: ({ row }) => {
      const note = row.original.note || "—";

      return (
        <Tooltip title={note} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {note}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },
 {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },
 
  {
    accessorKey: "PriorityName",
    header: "Priority Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },
  
  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },

  {
    accessorKey: "LeadTypeName",
    header: "Lead Type",
    size: 20,
  },

  {
    accessorKey: "MediumName",
    header: "Medium Name",
    size: 20,
  },
  {
    accessorKey: "SourceName",
    header: "Source Type",
    size: 20,
  },

  {
    header: "Description",
    accessorKey: "description",
    Cell: ({ row }) => {
      const description = row.original.description || "—";

      return (
        <Tooltip title={description} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {description}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },
  {
    accessorKey: "leadTime",
    header: "Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadTime).toLocaleDateString()}</div>
    ),
  },

  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },

{
    accessorKey: "details",
    header: "Property",
    size: 15,
    Cell: ({ row }) => {
      return row.original.propertyid === null ? (
        <span>Disable</span>
      ) : (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`view/${row.original.userid}/details/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Details
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "edit",
    header: "Edit",
    size: 15,
    Cell: ({ row }) => {
      return (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={EDIT_LEAD_ROUTE + row.original.leadid}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>

          <span className="text-sm font-medium transition-all group-hover:ms-4">
            {" "}
            Edit{" "}
          </span>
        </Link>
      );
    },
  },
];

export const LEAD_HISTORY_COLUMNS = [
  {
    accessorKey: "leadStatus",
    header: "Status",
    size: 20,
    Cell: ({ row }) => (
      <div>
        {STATUS_TYPES.find((item) => item.id === row.original.leadStatus)?.name}
      </div>
    ),
  },
  {
    accessorKey: "leadDate",
    header: "Date",
    size: 20,
    Cell: ({ row }) => {
      const leadDate = row.original?.followupdate;
      if (!leadDate) return "";
      const dateString = new Date(leadDate).toLocaleDateString("en-GB", {
        timeZone: "Asia/Karachi",
      });
      return dateString;
    },
  },
  {
    accessorKey: "leadTime",
    header: "Time",
    size: 20,
    Cell: ({ row }) => {
      const leadDate = row.original?.followupdate;
      if (!leadDate) return "";
      const timeString = new Date(leadDate).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Karachi",
      });
      return timeString;
    },
  },

  { accessorKey: "note", header: "Description", size: 20 },
];

export const AGENT_COLUMNS = [
  {
    accessorKey: "AgentId",
    header: "ID",
    size: 20,
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        {row.original.AgentId}
      </Link>
    ),
  },
  {
    header: "Image",
    accessorKey: "AgentImage",
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        <img
          src={AGENT_IMAGES_URL + row.original.AgentImage}
          alt={"Staff"}
          style={{ width: "70px", height: "70px" }}
        />
      </Link>
    ),
    size: 30,
  },
  {
    accessorKey: "AgentRegNo",
    header: "Reg No",
    size: 20,
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        {row.original.AgentRegNo}
      </Link>
    ),
  },
  {
    accessorKey: "firstName",
    header: "Name",
    size: 20,
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        {row.original.firstName}
      </Link>
    ),
  },
  {
    accessorKey: "AgentEmail",
    header: "Email",
    size: 20,
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        {row.original.AgentEmail}
      </Link>
    ),
  },

  {
    accessorKey: "LatestLeadDate",
    header: "Updated Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.LatestLeadDate;
      if (!value) return null;

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },

  {
    accessorKey: "AgentPhone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.AgentPhone}`}
        className="table-row-link"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.AgentPhone}
      </a>
    ),
  },

   {
    header: "Description",
    accessorKey: "AgentDescription",
    Cell: ({ row }) => {
      const description = row.original.AgentDescription || "—";

      return (
        <Tooltip title={description} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {description}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },

  {
    accessorKey: "LeadCountPerAgent",
    header: "Total Leads",
    size: 10,
    Cell: ({ row }) => (
      <Link
        className="table-row-link"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        {row.original.LeadCountPerAgent}
      </Link>
    ),
  },
  {
    accessorKey: "view",
    header: "Lead    ",
    size: 30,
    Cell: ({ row }) => (
      <Link
        className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
        to={`/agent/leads/${row.original.AgentId}`}
      >
        <span className="absolute -start-full transition-all group-hover:start-4">
          <svg
            className="size-3 rtl:rotate-180"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </span>

        <span className="text-sm font-medium transition-all group-hover:ms-4">
          Details
        </span>
      </Link>
    ),
  },
];
